import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { useGridQuery, useGridState } from '../../lib/grid.ts';
import { dt, type PlatformAuditRow } from '../../lib/platform.ts';
import { DataTable, type Column } from '../../components/DataTable.tsx';

const columns: Column<PlatformAuditRow>[] = [
  { key: 'seq', label: 'seq', width: '5rem', align: 'right', filter: 'none' },
  { key: 'occurredAt', label: '시각', width: '10rem', filter: 'date', render: (r) => dt(r.occurredAt) },
  { key: 'actorName', label: '운영자', width: '7rem', sortable: false },
  { key: 'action', label: '행위', width: '13rem', filter: 'select' },
  { key: 'targetType', label: '대상 유형', width: '8rem', filter: 'text' },
  { key: 'targetName', label: '대상', width: '10rem', sortable: false, render: (r) => r.targetName || (r.targetId?.slice(0, 8) ?? '—') },
  { key: 'ip', label: 'IP', width: '8rem', filter: 'text' },
  { key: 'detail', label: '내용', row: 2, span: 7, wrap: true, sortable: false, render: (r) => <span className="text-[11px] text-slate-600 font-mono">{JSON.stringify(r.detail).slice(0, 140)}</span> },
];
/** 플랫폼 활동 로그 = 플랫폼 테넌트 접속기록 체인 */
export function PlatformAuditPage() {
  const { state, set } = useGridState('pa', { sort: { col: 'seq', dir: 'desc' } });
  const data = useGridQuery<PlatformAuditRow>('platform-audit', '/platform/audit/grid', state);
  return (
    <div>
      <PageHeader title="플랫폼 · 활동 로그" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="platform-audit" columns={columns} data={data.data} state={state} onChange={set} rowKey={(r) => r.seq} isFetching={data.isFetching} />
    </div>
  );
}
